import { Box, Checkbox, CircularProgress, FormControlLabel } from '@mui/material'
import * as React from 'react'
import { useEffect } from 'react'

import ConfirmationDialog from './ConfirmationDialog'
import { AvatarPlus } from '../../utils/gravatar'
import { useParticipants } from '../hooks/useUsers'

export default function UnregistrationConfirmationDialog({ open, user, session, selfRegister, actions }) {
  const participants = selfRegister ? session.participants.filter((p) => p.id === user.resourceId) : session.participants
  const [selectedParticipants, setSelectedParticipants] = React.useState([])
  const { users: participantUsers, isLoading } = useParticipants(participants)

  const wrappedActions = {
    ...actions,
    cancel: {
      ...actions.cancel,
      onClick: () => {
        actions.cancel.onClick()
        setSelectedParticipants([])
      },
    },
    confirm: {
      ...actions.confirm,
      onClick: () => {
        actions.confirm.onClick(selectedParticipants)
        setSelectedParticipants([])
      },
    },
  }

  const handleParticipantToggle = (participant) => {
    setSelectedParticipants((prev) => {
      if (prev.some((p) => p.id === participant.id && p.familyId === participant.familyId)) {
        return prev.filter((p) => p.id !== participant.id && p.familyId !== participant.familyId)
      } else {
        return [...prev, { id: participant.id, familyId: participant.familyId }]
      }
    })
  }

  useEffect(() => {
    if (open) {
      if (selfRegister) {
        const myParticipants = session.participants?.filter((p) => p.id === user.resourceId) || []
        if (myParticipants.length === 1) {
          setSelectedParticipants(myParticipants)
        }
      }
    }
  }, [open, selfRegister, session, user])

  return (
    <ConfirmationDialog
      open={open}
      title="Unregister Participants"
      content={selfRegister ? 'Are you sure you want to unregister from this session?' : 'Select participants to unregister:'}
      actions={wrappedActions}
    >
      {/* Participants List */}
      <Box sx={{ mt: 2 }}>
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          participantUsers.map((participantUser) => {
            return (
              <FormControlLabel
                key={participantUser.resourceId + participantUser.familyId}
                control={
                  <Checkbox
                    checked={selectedParticipants.some((p) => p.id === participantUser.resourceId && p.familyId === participantUser.familyId)}
                    onChange={() => handleParticipantToggle({ id: participantUser.resourceId, familyId: participantUser.familyId })}
                  />
                }
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AvatarPlus user={participantUser} size="mini" />
                  </Box>
                }
              />
            )
          })
        )}
      </Box>
    </ConfirmationDialog>
  )
}
